// City guides for bloxsocial.live/things-to-do. Same block format as the blog (see blog/posts.js):
//   { p }, { h }, { list }, { quote }, { tip, title? }
// `lat`/`lng` find live plans in the city; `match` finds its Blox events by name, venue or address.

const cities = [
  {
    slug: "lucknow",
    name: "Lucknow",
    state: "Uttar Pradesh",
    emoji: "🕌",
    accent: "#ffb547",
    lat: 26.85, lng: 80.95,
    match: ["lucknow", "gomti nagar", "hazratganj", "amity lucknow"],
    excerpt: "Kebabs in Chowk, evenings in Hazratganj, sunsets on the Gomti and a lot of history in between: a student's guide to the City of Nawabs.",
    blocks: [
      { p: "Lucknow is slow in the best way. People take their food seriously, their manners even more so, and there's always a reason to stay out a little longer. Here's where to start." },
      { h: "Eat like a local" },
      { list: [
        "Tunday Kababi in Aminabad or Chowk: the galouti kebab with a sheermal is the reason people visit Lucknow.",
        "Chowk at night: kebabs, nihari and kulfi from the street stalls in the old city.",
        "Basket chaat at Royal Cafe in Hazratganj, then a walk down the strip (locals call it \"ganjing\").",
        "Gomti Nagar for cafés, brunch spots and late coffee with friends.",
      ] },
      { h: "See the old city" },
      { list: [
        "Bara Imambara and the Bhool Bhulaiya maze: go with a guide, or go with friends and get lost on purpose.",
        "Rumi Darwaza and the Chhota Imambara, both a short walk away.",
        "The Residency: ruins and gardens from 1857, quiet and good for photos.",
      ] },
      { h: "Evenings outdoors" },
      { list: [
        "Marine Drive along the Gomti for sunset walks and street food.",
        "Janeshwar Mishra Park: huge, green and good for cycling or a picnic.",
        "Ambedkar Memorial Park, lit up after dark.",
      ] },
      { h: "Shopping" },
      { list: [
        "Aminabad and Chowk for chikankari kurtas, at far better prices than anywhere else.",
        "Phoenix Palassio and Lulu Mall when it's too hot to be outside.",
      ] },
      { tip: "Most of the old-city sights are close together. Start at Bara Imambara in the morning and end in Chowk for dinner.", title: "Make a day of it" },
    ],
  },
  {
    slug: "delhi",
    name: "Delhi",
    state: "Delhi NCR",
    emoji: "🏛️",
    accent: "#ff6b6b",
    lat: 28.61, lng: 77.21,
    match: ["delhi", "new delhi", "gurgaon", "gurugram", "noida"],
    excerpt: "Old Delhi food walks, Lodhi Garden mornings, Hauz Khas evenings and markets for every budget, all on the Metro.",
    blocks: [
      { p: "Delhi is big, loud and full of plans waiting to happen. The Metro reaches almost everywhere on this list, so you rarely need more than a card and comfortable shoes." },
      { h: "Old Delhi" },
      { list: [
        "Chandni Chowk on foot: Paranthe Wali Gali, jalebis and sweets, then Jama Masjid.",
        "Go early in the day. It gets crowded fast and the lanes are best before noon.",
      ] },
      { h: "Gardens and monuments" },
      { list: [
        "Lodhi Garden for morning walks and picnics, then the Lodhi Art District murals nearby.",
        "Humayun's Tomb and Sunder Nursery next door: one ticket's worth of calm in the middle of the city.",
        "Qutub Minar and Mehrauli's ruins for an afternoon of history.",
        "India Gate and Kartavya Path in the evening.",
      ] },
      { h: "Hang out" },
      { list: [
        "Hauz Khas Village: cafés over the lake, and the Deer Park next door.",
        "Connaught Place for a bit of everything: food, shopping and people-watching.",
        "Majnu ka Tilla for momos, laphing and Tibetan cafés.",
        "Kamla Nagar near North Campus and Satya Niketan near South Campus for cheap student food.",
      ] },
      { h: "Shopping" },
      { list: [
        "Sarojini Nagar for clothes at student prices (bargain politely).",
        "Janpath and Dilli Haat for handicrafts and food stalls from every state.",
      ] },
      { tip: "Delhi summers are brutal. Save outdoor plans for October to March, or for early mornings.", title: "Pick your season" },
    ],
  },
  {
    slug: "bangalore",
    name: "Bangalore",
    state: "Karnataka",
    emoji: "🌳",
    accent: "#2bc46b",
    lat: 12.97, lng: 77.59,
    match: ["bangalore", "bengaluru", "koramangala", "indiranagar"],
    excerpt: "Parks, dosas, gigs and a weekend sunrise at Nandi Hills: Bangalore makes it easy to find your people.",
    blocks: [
      { p: "Good weather most of the year means Bangalore lives outdoors: parks in the morning, cafés in the afternoon and gigs at night." },
      { h: "Breakfast first" },
      { list: [
        "Vidyarthi Bhavan in Basavanagudi for crisp benne dosas (expect a queue on weekends).",
        "MTR for a classic South Indian breakfast.",
        "VV Puram's food street in the evenings: snacks, sweets and chaats one after another.",
      ] },
      { h: "Green spaces" },
      { list: [
        "Cubbon Park for walks, runs and reading under the trees.",
        "Lalbagh Botanical Garden, especially during its flower shows around Republic Day and Independence Day.",
      ] },
      { h: "Going out" },
      { list: [
        "Church Street for bookshops, cafés and live music nearby.",
        "Indiranagar's 100 Feet Road and Koramangala for food, bars and stand-up comedy shows.",
        "Commercial Street for shopping on a budget.",
      ] },
      { h: "Weekend trip" },
      { list: [
        "Nandi Hills for sunrise above the clouds, about two hours away: leave very early.",
        "Bangalore Palace if you'd rather stay in the city.",
      ] },
      { tip: "Traffic decides everything here. Plan around Namma Metro lines and meet near a station.", title: "Beat the traffic" },
    ],
  },
  {
    slug: "mumbai",
    name: "Mumbai",
    state: "Maharashtra",
    emoji: "🌊",
    accent: "#4f9dff",
    lat: 19.08, lng: 72.88,
    match: ["mumbai", "bombay", "bandra", "andheri", "navi mumbai", "thane"],
    excerpt: "Sunsets on Marine Drive, vada pav at every corner, sea-facing promenades and the best street food in the country.",
    blocks: [
      { p: "Mumbai never really stops, which makes it the easiest city to make plans in. Pick a neighbourhood, take the local train, and walk." },
      { h: "By the sea" },
      { list: [
        "Marine Drive at sunset, then the lights of the Queen's Necklace after dark.",
        "Bandra's Bandstand and Carter Road promenades for evening walks.",
        "Juhu Beach for pav bhaji and street food on the sand.",
      ] },
      { h: "South Mumbai" },
      { list: [
        "Gateway of India and the Colaba Causeway market.",
        "Kala Ghoda's galleries and cafés, and its arts festival every February.",
        "Old Irani cafés for bun maska and chai.",
      ] },
      { h: "Food you have to try" },
      { list: [
        "Vada pav and pav bhaji, anywhere and everywhere.",
        "Mohammed Ali Road during Ramzan for an all-night food walk.",
      ] },
      { h: "Get out of the city" },
      { list: [
        "Sanjay Gandhi National Park and the Kanheri Caves, inside the city limits.",
        "Prithvi Theatre in Juhu for plays and its café.",
        "Lonavala in the monsoon, an easy train ride away.",
      ] },
      { tip: "Avoid local trains at rush hour unless you're used to them. Midday and weekends are much easier.", title: "Ride the locals" },
    ],
  },
  {
    slug: "chennai",
    name: "Chennai",
    state: "Tamil Nadu",
    emoji: "🏖️",
    accent: "#ff8a3d",
    lat: 13.08, lng: 80.27,
    match: ["chennai", "madras", "srm", "kattankulathur", "besant nagar"],
    excerpt: "Filter coffee, beach evenings, Mylapore's temples and a day trip to Mahabalipuram: a guide for students new to Chennai.",
    blocks: [
      { p: "Chennai rewards early starts and late evenings. Spend the hot afternoons indoors, then head to the beach when the sea breeze kicks in." },
      { h: "Coffee and food" },
      { list: [
        "Filter coffee in Mylapore, with idli or pongal on the side.",
        "Saravana Bhavan and Murugan Idli Shop for a classic South Indian meal.",
        "Besant Nagar's beachside stalls and cafés for evening snacks.",
      ] },
      { h: "Beaches" },
      { list: [
        "Marina Beach at sunrise or sunset: one of the longest urban beaches anywhere.",
        "Elliot's Beach in Besant Nagar: calmer, cleaner and the student favourite.",
      ] },
      { h: "Culture" },
      { list: [
        "Kapaleeshwarar Temple and the streets of Mylapore around it.",
        "San Thome Basilica and Fort St. George for history.",
        "December's music season (Margazhi), when sabhas across the city host concerts and dance.",
        "The Theosophical Society gardens in Adyar for a quiet walk.",
      ] },
      { h: "Shopping and day trips" },
      { list: [
        "T. Nagar's Ranganathan Street and Pondy Bazaar for clothes and everything else.",
        "Mahabalipuram for the Shore Temple and the rock carvings, about an hour down the coast.",
        "DakshinaChitra on the way back, for South Indian art and crafts.",
      ] },
      { tip: "Carry water and sunscreen for any daytime plan, even in winter.", title: "Stay cool" },
    ],
  },
  {
    slug: "vellore",
    name: "Vellore",
    state: "Tamil Nadu",
    emoji: "🏰",
    accent: "#9b7bff",
    lat: 12.92, lng: 79.13,
    match: ["vellore", "vit", "katpadi"],
    excerpt: "A fort with a moat, a golden temple, quick escapes to the Yelagiri hills and everything students around VIT need for the weekend.",
    blocks: [
      { p: "Vellore is a student town at heart. Most weekends start around Katpadi and VIT, but there's more to the city than campus." },
      { h: "In the city" },
      { list: [
        "Vellore Fort: walk the walls and moat, and visit the Jalakandeswarar Temple and the museum inside.",
        "Sripuram Golden Temple, best seen when it's lit up in the evening.",
        "Long Bazaar for shopping and street food.",
      ] },
      { h: "Around campus" },
      { list: [
        "Katpadi and Gandhinagar for cafés, late-night food and group dinners.",
        "VIT's Riviera and graVITas fests: the busiest weeks of the year.",
      ] },
      { h: "Weekend escapes" },
      { list: [
        "Yelagiri hills for a cooler weekend: boating, trekking and viewpoints, a short drive away.",
        "Amirthi forest for a small zoo and a waterfall after the rains.",
      ] },
      { tip: "Yelagiri trips are cheaper and easier as a group. Start a plan in Blox and split the cab.", title: "Go together" },
    ],
  },
  {
    slug: "bhubaneswar",
    name: "Bhubaneswar",
    state: "Odisha",
    emoji: "🛕",
    accent: "#ff5fa2",
    lat: 20.30, lng: 85.82,
    match: ["bhubaneswar", "kiit", "patia"],
    excerpt: "The Temple City, Nandankanan's white tigers, Odia sweets and easy day trips to Puri and Konark.",
    blocks: [
      { p: "Bhubaneswar is green, easy to get around and close to some of Odisha's best day trips. A good city for students who like exploring." },
      { h: "Temples and history" },
      { list: [
        "Lingaraj Temple, the city's landmark (non-Hindus can see it from the viewing platform outside).",
        "Mukteswar and Rajarani temples for their stone carvings.",
        "Udayagiri and Khandagiri caves, cut into the hills over two thousand years ago.",
        "Dhauli's Shanti Stupa for the view over the Daya river.",
      ] },
      { h: "Outdoors" },
      { list: [
        "Nandankanan Zoological Park and its white tigers.",
        "Ekamra Haat for crafts, handlooms and food stalls.",
      ] },
      { h: "Eat" },
      { list: [
        "Dahibara aloodum from a street stall: the city's favourite snack.",
        "Chhena poda, Odisha's baked cheese dessert.",
        "Saheed Nagar's evening food stalls, and the cafés around Patia near KIIT.",
      ] },
      { h: "Day trips" },
      { list: [
        "Puri for the beach and the Jagannath Temple.",
        "Konark Sun Temple, a UNESCO World Heritage Site, often combined with Puri in one day.",
      ] },
      { tip: "Puri and Konark make a great group day trip. Start early to see both before sunset.", title: "Plan the coast trip" },
    ],
  },
];

export const findCity = (slug) => cities.find((c) => c.slug === slug);
export default cities;
